import { useEventLogging } from '../../../models/Logging';
import * as React from 'react';

export function useLogPageView({ pageName, loggingCategory }: { pageName: string; loggingCategory: string }) {
	const { logPageView } = useEventLogging(loggingCategory);
	React.useEffect(() => {
		logPageView(pageName);
	}, [logPageView, pageName]);
}
